import { Data, ModelData } from "@core/content/types";
import {
  createCreatorContentPipeline,
  toTargetNames as toTargetNamesCore,
} from "@core/content/creator/CreatorContentStore";
import { getExperienceMode, setExperienceMode } from "@core/utils/experienceMode";

export const toTargetNames = toTargetNamesCore;

// Use the normalized launch.eyejack.io `/json` endpoint. The updated core's
// CreatorMapper detects artwork type from `payload.type` (expects
// "world-target"/"image-target"/"collection"); the legacy
// launch.eyejackapp.com `?j=1` endpoint returns raw CMS schema (type: "artwork")
// which the new mapper drops, yielding empty contentData.
const ONSITE_CREATOR_DATA_SOURCE =
  "https://launch.eyejack.io/Artwork-f1c75154-c348-4cc1-a388-92901a3f78c4/json";
const OFFSITE_CREATOR_DATA_SOURCE =
  "https://launch.eyejack.io/Artwork-7721c88a-df6a-43da-b517-adf1148ed0cf/json";

const ONSITE_PATH_PREFIX = "/onsite";
const EXPERIENCE_STORAGE_KEY = "experience_mode";

const resolveCreatorDataSource = (): string => {
  if (typeof window === "undefined") return OFFSITE_CREATOR_DATA_SOURCE;

  const pathname = window.location.pathname || "/";
  const isOnsitePath =
    pathname === ONSITE_PATH_PREFIX || pathname.startsWith(`${ONSITE_PATH_PREFIX}/`);
  const storedMode = getExperienceMode(EXPERIENCE_STORAGE_KEY);

  if (isOnsitePath || storedMode === "onsite") {
    setExperienceMode("onsite", EXPERIENCE_STORAGE_KEY);
    return ONSITE_CREATOR_DATA_SOURCE;
  }

  return OFFSITE_CREATOR_DATA_SOURCE;
};

export const CREATOR_DATA_SOURCE = resolveCreatorDataSource();
console.log('CREATOR_DATA_SOURCE', CREATOR_DATA_SOURCE);
// Fallback/manual content for Seaqueen if creator source is unavailable.
export const MANUAL_CONTENT: Data[] = [
  // {
  //   id: PanelData.partitionkey ?? "queens-garden",
  //   type: "scene",
  //   name: PanelData.name ?? "Queens Gardens",
  //   description: "Boorloo Heritage Festival",
  //   content: [
  //     {
  //       type: "audio",
  //       path: Audio,
  //     },
  //   ],
  // },
];

const creatorPipeline = createCreatorContentPipeline({
  creatorDataSource: CREATOR_DATA_SOURCE,
  manualContent: MANUAL_CONTENT,
});

export const initializeContentData = creatorPipeline.initializeContentData;
export const resolveDeferredContentData = creatorPipeline.resolveDeferredContentData;
export const getContent = creatorPipeline.getContent;

export const getContentData = (): ModelData[] =>
  creatorPipeline.getContentData() as ModelData[];

export const getMicrositeData = () => creatorPipeline.getMicrositeData();
export const getInitialContentId = () => creatorPipeline.getInitialContentId();
